import { render } from "./MainNavigationHandler.vue?vue&type=template&id=4e771f25&scoped=true&ts=true"
import script from "./MainNavigationHandler.vue?vue&type=script&lang=ts"
export * from "./MainNavigationHandler.vue?vue&type=script&lang=ts"

import "./MainNavigationHandler.vue?vue&type=style&index=0&id=4e771f25&lang=less&scoped=true"

import exportComponent from "D:\\a\\1\\s\\src\\Bolia.Website\\clients\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e771f25"]])

export default __exports__